import React from "react";
import Uploader from "../components/Upload/UploadImage";
import UploadFile from "../components/Upload/UploadFile";
 
function UploadIMG({ setPageHeader }) {
  setPageHeader("Upload Image");
  return (
    <div
      style={{
        textAlign: "center",
      }}
    >
      <Uploader />
      {/* <div style={{ marginTop: "20px" }}>
        <StablePrime url="/" data={{}} identity="Images" />
      </div> */}
    </div>
  );
}

export default UploadIMG;
